/* Clarity wraps customElements.define. Eastside vendor.min.js then replaces
   HTMLElement with a PivotCtor constructor. If define still points at native
   (or Clarity's wrap of native), every Eastside tag throws Illegal constructor.

   1. Snapshot native define is in theme.liquid before content_for_header.
   2. Undo Clarity's early instance wrap so Eastside can patch the prototype.
   3. The moment Eastside sets window.HTMLElement, pin customElements.define
      to Eastside's prototype.define (PivotCtor) and ignore later Clarity wraps. */
(function () {
  var native = window.__cwNativeCE;
  var registry = window.customElements;
  if (!registry) return;

  function isEastsideDefine(fn) {
    return !!(fn && String(fn).indexOf("PivotCtor") !== -1);
  }

  function pinEastsideDefine() {
    var protoDefine = CustomElementRegistry.prototype.define;
    if (!isEastsideDefine(protoDefine)) return false;
    try {
      if (Object.prototype.hasOwnProperty.call(registry, "define")) {
        delete registry.define;
      }
    } catch (e) {}
    try {
      Object.defineProperty(registry, "define", {
        configurable: true,
        enumerable: true,
        get: function () {
          return CustomElementRegistry.prototype.define;
        },
        set: function () {}
      });
    } catch (e2) {
      registry.define = protoDefine;
    }
    return true;
  }

  try {
    if (Object.prototype.hasOwnProperty.call(registry, "define") && !isEastsideDefine(registry.define)) {
      delete registry.define;
    }
  } catch (e3) {}

  if (native && native.define && !isEastsideDefine(CustomElementRegistry.prototype.define)) {
    try {
      CustomElementRegistry.prototype.define = native.define;
      if (native.get) CustomElementRegistry.prototype.get = native.get;
    } catch (e4) {}
  }

  if (!pinEastsideDefine()) {
    var currentHE = window.HTMLElement;
    try {
      Object.defineProperty(window, "HTMLElement", {
        configurable: true,
        enumerable: true,
        get: function () {
          return currentHE;
        },
        set: function (value) {
          currentHE = value;
          try {
            Object.defineProperty(window, "HTMLElement", {
              configurable: true,
              writable: true,
              enumerable: true,
              value: value
            });
          } catch (e5) {
            currentHE = value;
          }
          pinEastsideDefine();
        }
      });
    } catch (e6) {}

    var ticks = 0;
    var timer = setInterval(function () {
      ticks += 1;
      if (pinEastsideDefine() || ticks > 250) clearInterval(timer);
    }, 16);
  }

  document.addEventListener(
    "click",
    function (event) {
      var nav = event.target && event.target.closest && event.target.closest("east-slider-nav");
      if (!nav) return;
      var wrap = nav.closest(".featured-carousel__slider-wrap") || nav.parentElement;
      var slider = wrap && wrap.querySelector("east-slider");
      if (!slider || !slider.swiper) return;
      event.preventDefault();
      event.stopPropagation();
      if (nav.id.indexOf("nav-right") !== -1) slider.swiper.slideNext();
      else slider.swiper.slidePrev();
    },
    true
  );
})();
